export const MAX_PROJECT_INSTRUCTIONS_CODE_POINTS = 4000

export function countUnicodeCodePoints(value: string): number {
  return Array.from(value).length
}

export function truncateToUnicodeCodePoints(
  value: string,
  maxCodePoints = MAX_PROJECT_INSTRUCTIONS_CODE_POINTS
): string {
  const codePoints = Array.from(value)
  return codePoints.length > maxCodePoints ? codePoints.slice(0, maxCodePoints).join("") : value
}
